/*=========================================================================================
  File Name: actions.js
  Namespace: lpaths
  Description: Vuex Store - Learning Path actions
==========================================================================================*/
import {
  createLPath,
  editLPath,
  getLPath,
  getLPathsWithoutAdapter,
  listLPaths,
} from '@/services/lpaths.service'

const actions = {
  async getLPathAction ({ commit }, { lpathId }) {
    const response = await getLPath({
      lpathId
    })
    if (response) {
      commit('STORE_CURRENT_LPATH', response)
    }
    return response
  },
  async getAllLPaths({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    const response = await listLPaths(params)
    if (response) {
      commit('STORE_LIST_LPATHS', response)
    }
    return response
  },
  async saveLPathToApi({
    commit, getters, rootState
  }) {
    let response
    if (getters.getCurrentLPath.id) {
      response = await editLPath({
        ...getters.getCurrentLPath,
        lpathId: getters.getCurrentLPath.id,
        company: rootState.app.company
      })
    } else {
      response = await createLPath({
        ...getters.getCurrentLPath,
        company: rootState.app.company
      })
    }
    commit('STORE_CURRENT_LPATH', response)
    return response
  },
  saveLPathToStore({
    commit
  }, payload) {
    commit('STORE_CURRENT_LPATH', payload)
  },
  addLeafToContentStructure({
    commit
  }, leaf) {
    commit('ADD_LEAF_TO_STRUCTURE', leaf)
  },
  removeLeafToContentStructure({
    commit
  }, leaf) {
    commit('REMOVE_LEAF_TO_STRUCTURE', leaf)
  },
  resetCurrentLPath({
    commit
  }) {
    commit('RESET_CURRENT_LPATH')
  },
  renameGroupOfContentStructure({
    commit
  }, nameObject) {
    commit('RENAME_GROUP', nameObject)
  },
  addGroupToContentStructure({
    commit
  }, newGroup) {
    commit('ADD_GROUP_TO_STRUCTURE', newGroup)
  },
  removeGroupToContentStructure({
    commit
  }, group) {
    commit('REMOVE_GROUP_OF_STRUCTURE', group)
  },
  updateContentStructure({
    commit
  }, contentToOrder) {
    commit('UPDATE_CONTENT_ORDER', contentToOrder)
  },
  deleteContentStructure({
    commit
  }) {
    commit('RESET_CURRENT_LPATH_CONTENT')
  },
  async searchLPaths({
    rootState
  }, params = {}) {
    params.company = rootState.app.company
    const response = await listLPaths(params)
    return response
  },
  async searchLPathsWithoutAdapter({ rootState }, params = {}) {
    params.company = rootState.app.company
    const response = await getLPathsWithoutAdapter(params)
    return response
  },
}

export default actions
